<template>
  <v-content style="padding:0">
    <v-layout row align-top style="margin:0">
      <v-flex xs12 md8 class="justify-center align-center" >
        <TwentyTwenty
          :before="slide.before"
          :after="slide.after" />
      </v-flex>
      <v-flex xs12 md4 pa-3>
        <v-layout column class="">
          <v-flex>
            <v-avatar color="red" size="120">
              <img
                :src="slide.avatar"
                :alt="slide.name"
              >
            </v-avatar>
          </v-flex>
          <v-flex my-4>
            <h2>
              {{slide.name}}
            </h2>
            <h3>
              "{{slide.story}}"
            </h3>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TwentyTwenty from 'vue-twentytwenty'

export default {
  components: { TwentyTwenty },
  props: { slide: Object }
}
</script>

<style scoped>
h2 {
  padding:1em 0;
}
</style>